import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaInfo } from "react-icons/fa";

function DeparturesForm ({flightData, onCancel}) {
    const [masterData, setMasterData] = useState(null);
    const [findMaster, setFindMaster] = useState('');
    const [tableData, setTableData] = useState([]);

    const mockData = [
        {
          master: '111-12345678',
          ori: 'CMX',
          dest: 'GDL',
          p_ori: 2,
          w_ori: 27.00,
          destiny: 'GDL',
          date: '2025-04-10',
          is_transit: 0,
          active_billing: 1
        },
        {
          master: '215-88997721',
          ori: 'MAD',
          dest: 'MEX',
          p_ori: 45,
          w_ori: 120,
          destiny: 'MEX',
          date: '2025-21-10',
          is_transit: 1,
          active_billing: 0
        },
    ];

    const handleInputChange = (e) => {
        let value = e.target.value;

        if (value.length > 3 && value[3] !== "-") {
            value = value.slice(0, 3) + "-" + value.slice(3);
        }

        setFindMaster(value);
    };

    const handleSearch = () => {
        if (!findMaster.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Campo requerido',
                text: 'El campo master es necesario',
            });
            return;
        }

        const found = mockData.find((item) => item.master === findMaster);

        if (!found) {
            Swal.fire({
                icon: 'error',
                title: 'No encontrada',
                text: 'No se encontró ninguna master con ese número',
            });
            return;
        }

        if (found.active_billing === 0) {
            Swal.fire({
                icon: 'info',
                title: 'Sin facturas activas',
                text: 'La master no cuenta con ninguna factura activa, favor de verificar',
            });
        } else {
            Swal.fire({
                title: '',
                html: `
                    <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                        Información
                    </div>
                    <div style="padding: 10px;">
                    <div class="container-fluid">
                        <p><strong>Master:</strong> ${found.master}</p>
                        <div class="row">
                            <div class="col-6">
                                <p><strong>Origen:</strong> ${found.ori}</p>
                            </div>
                            <div class="col-6">
                                <p><strong>Destino:</strong> ${found.dest}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <p><strong>Piezas:</strong> ${found.p_ori}</p>
                            </div>
                            <div class="col-6">
                                <p><strong>Peso:</strong> ${found.w_ori} kg</p>
                            </div>
                        </div>
                    </div>
                    `,
                showCancelButton: true,
                confirmButtonText: 'Agregar',
                cancelButtonText: 'Cancelar',
                preConfirm: () => {
                    const isDuplicate = tableData.some((item) => item.master === found.master);
                    if (isDuplicate) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Duplicado',
                            text: 'La master ya ha sido asignada a este vuelo',
                        });
                        return false;
                    }
                    setTableData(prev => [...prev, {
                        master: found.master,
                        piezas: found.p_ori,
                        peso: found.w_ori,
                        destino: found.dest,
                        transito: found.is_transit ? 'Sí' : 'No',
                        eliminar: false // propiedad para saber si se elimina o no una fila
                    }]);
                }
            });
            setMasterData(found); // Si necesitas usar luego la info
        }
    };

    const handleChangeTableValue = (index, field, value) => {
        const newData = [...tableData];
        newData[index][field] = value;
        setTableData(newData);
    };

    const handleCheckboxChange = (index) => {
        const newData = [...tableData];
        newData[index].eliminar = !newData[index].eliminar;
        setTableData(newData);
    };

    const handleDelete = () => {
        const haySeleccionados = tableData.some(item => item.eliminar);

        if (!haySeleccionados) {
            Swal.fire({
                icon: 'warning',
                title: 'Debe seleccionar al menos una guía',
            });
            return;
        }

        const nuevosDatos = tableData.filter(item => !item.eliminar);
        setTableData(nuevosDatos);
    };

    const handleSave = async () => {
        if (tableData.length === 0) {
            Swal.fire({
                title: '',
                html: `
                    <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                        Error
                    </div>
                    <div style="padding: 10px;">
                    <div class="alert alert-danger text-start">
                        <p>No hay guías asignadas</p>
                    </div>
                `,
                text: 'No hay guías asignadas',
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn-amc-blue",
                },
            });
            return;
        }

        const horaInput = document.getElementById("time");
        const hora = horaInput ? horaInput.value : "";

        const result = await Swal.fire({
            title: '¿Seguro que deseas guardar la información?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                confirmButton: "btn-amc-blue",
                cancelButton: "btn-amc-pink",
            },
        });

        if (result.isConfirmed) {
            if (!hora) {
                Swal.fire({
                    title: '',
                    html: `
                        <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                            Error
                        </div>
                        <div style="padding: 10px;">
                        <div class="alert alert-danger text-start">
                            <p>Debe llenar el campo hora</p>
                        </div>
                    `,
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn-amc-blue",
                    },
                });
                return;
            } else {
                const formattedData = tableData.map((item) => ({
                    master_id: item.master,
                    pieces: item.piezas.toString(),
                    weight: Number(item.peso).toLocaleString("es-MX", { minimumFractionDigits: 3 }),
                    flight: flightData.flight,
                    year: flightData.year,
                    hora: hora,
                    is_transit: item.transito === "Sí" ? "1" : "0"
                }));

                console.log("Datos enviados al backend:");
                console.log(formattedData);

                Swal.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito',
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn-amc-blue",
                    },
                });
            }
        }
    };

    const showMasterInfo = (item) => {
        Swal.fire({
            title: '',
            html: `
                    <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                        Información
                    </div>
                    <div style="padding: 10px;">
                    <div class="container-fluid">
                        <p><strong>Master:</strong> ${item.master}</p>
                        <div class="row">
                            <div class="col-6">
                                <p><strong>Piezas Totales:</strong> ${item.piezas}</p>
                            </div>
                            <div class="col-6">
                                <p><strong>Peso Total:</strong> ${item.peso}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <p><strong>Piezas Actuales:</strong> ${item.p_ori}</p>
                            </div>
                            <div class="col-6">
                                <p><strong>Peso Actual:</strong> ${item.w_ori}</p>
                            </div>
                        </div>
                    </div>
                    `,
            confirmButtonText: 'Cerrar',
        })
    }

    /* const handleSearc = async () => {
        try {
            const master = "261-20012260";
            const res = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_capture/getMaster`,
            {
                params: { master },
                headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            }
            );

            if (res.data.code == 1) {
            setMasterData(res.data);
            console.log(res.data); // mejor aquí
            } else {
            console.log(res);
            Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error. Intente nuevamente", "error");
        }
    };

    useEffect(() => {
        handleSearc();
    }, []); */

    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col-6 d-flex align-items-center">
                    <label htmlFor="find_master" className="amc-label me-2">Master:</label>
                    <input 
                        type="text"
                        className="form-control me-2 w-25"
                        id="find_master"
                        name="find_master"
                        value={findMaster}
                        onChange={handleInputChange}
                    />
                    <button className='btnn' onClick={handleSearch} >Buscar</button>
                </div>
                <div className="col-6 d-flex align-items-center justify-content-end">
                    <label htmlFor="time" className="amc-label me-2">Hora:</label>
                    <input 
                        type="time"
                        className="form-control w-25"
                        id="time"
                        name="time"
                    />
                </div>

                <table className="table table-striped mt-4">
                    <thead className="text-center">
                        <tr>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Master</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Piezas</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Peso</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Destino</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Tránsito</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Eliminar</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Editar</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {tableData.map((item, index) => (
                            <tr key={index}>
                                <td>{item.master} <span style={{ cursor: 'pointer', color: '#020C41' }} onClick={() => showMasterInfo(item)}> <FaInfo /> </span></td>
                                <td>
                                    <input
                                        type="number"
                                        value={item.piezas}
                                        onChange={(e) => handleChangeTableValue(index, 'piezas', e.target.value)}
                                        className="form-control text-center"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={item.peso}
                                        onChange={(e) => handleChangeTableValue(index, 'peso', e.target.value)}
                                        className="form-control text-center"
                                    />
                                </td>
                                <td>{item.destino}</td>
                                <td>{item.is_transit === 1 ? 'Sí' : 'No'}</td>
                                <td><input type="checkbox" checked={item.eliminar} onChange={() => handleCheckboxChange(index)} /></td>
                                <td><input type="checkbox" /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="col mt-4 d-flex justify-content-end gap-3">
                    <button className='btnn' onClick={handleDelete} >Eliminar</button>
                    <button className='btnn' onClick={handleSave} >Guardar</button>
                </div>
            </div>
        </div>
    );
}

export default DeparturesForm;